(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["k-mega-menu-mobile-footer"] && !Shopify.designMode) return;
  try {
    (function(){
    if (!customElements.get('header-drawer')) {
        const mobileNavFooter = document.querySelector('.k-mega-menu-mobile-footer');
        if(!mobileNavFooter) return;

        const details = mobileNavFooter.querySelector('.drawer-localization');
        if(!details) return;

        mobileNavFooter.addEventListener('click', function(event){
            let target = event.target || null;
            let classList = target && target.classList || [];
            if(classList.contains('menu-drawer__close-button') || classList.contains('menu-drawer__back-button')){
                localizationClose(details);
            }
        });
    }
    function localizationClose(details){
        const summary = details.querySelector('summary');

        if (!summary) return;

        summary.setAttribute('aria-expanded', 'false');
        details.classList.remove('menu-open');
        details.removeAttribute('open');

    }
})();
  } catch(e) { console.error(e); }
})();

})();
